import createSvgIcon from '../Utils/CreateSvgIcon';

export const SignOut = createSvgIcon(
  <path d="M17.0001 7L15.5901 8.41L18.1701 11H8.00009L8.00009 13H18.1701L15.5901 15.58L17.0001 17L22.0001 12M4.00009 5L12.0001 5V3L2 3C2 4.5 2.00009 3.9 2.00009 5L2.00009 19C2.00009 20.1 2 20.5 2 21H12.0001L12.0001 19H4.00009L4.00009 5Z" />,
  'SignOut',
);
